import Vue from "vue";

Vue.component("AnswersList", () => import("./List.vue"));
Vue.component("FormCommentary", () => import("./Form.vue"));
Vue.component("ShowCommentary", () => import("./Show.vue"));
